const validation = {
  methods: {
    validateSelectError(selection) {
      return selection === null ? null : false;
    },
    validateSelectSuccess(selection) {
      return selection !== null ? true : null;
    },
    validateNotEmpty(value) {
      if (this.isEmpty(value)) {
        return null;
      }
      return value.length > 0;
    },
    validateEmpty(value) {
      if (this.isEmpty(value)) {
        return null;
      }
      return value.length === 0;
    },
    getStateForComponentValidation(changed, validated, invalid, valid) {
      if (changed === undefined || validated === undefined || invalid === undefined) {
        return null;
      }

      if (changed === true) {
        return valid;
      }

      const isInvalid = validated === true && invalid === true;

      if (isInvalid === true) {
        return valid;
      }

      return null;
    },
    isEmpty(value) {
      return value === null || value === undefined;
    },
    getStateForComponentValidationWithClickButton(
      changed,
      validated,
      invalid,
      valid,
      isContinueButtonClicked,
    ) {
      if (changed === undefined || validated === undefined || invalid === undefined) {
        return null;
      }

      if (invalid === true && isContinueButtonClicked === false) {
        return null;
      }

      if (changed === true) {
        return valid;
      }

      if (validated === true && invalid === true && isContinueButtonClicked === true) {
        return valid;
      }

      return null;
    },
  },
};
export default validation;
